<template>

    <div class="comment-container">
        <h3>¡Nuestros clientes nos recomiendan!</h3>

        <div class="d-flex d-flex-col">
            <div class="comment-block-container d-flex mr-2">
                <img src="https://3.cdnpt.com/images/1px.gif" class="comment-icon">
                <div class="comment-block">
                    <span class="comment-text">En general mi experiencia fue buena.</span>
                    <span class="small-comment"><span class="font-icons small icon-1-star small-comment icon-1-star-small"></span>Hector Ismael S.</span>
                </div>
            </div>

            <div class="comment-block-container d-flex mr-2">
                <img src="https://3.cdnpt.com/images/1px.gif" class="comment-icon">
                <div class="comment-block">
                    <span class="comment-text">El servicio fue excelente.</span>
                    <span class="small-comment"><span class="font-icons small icon-1-star small-comment icon-1-star-small"></span>Ana Margarita M.</span>
                </div>
            </div>

            <div class="comment-block-container d-flex">
                <img src="https://3.cdnpt.com/images/1px.gif" class="comment-icon">
                <div class="comment-block">
                    <span class="comment-text">La atención fue muy buena.</span>
                    <span class="small-comment"><span class="font-icons small icon-1-star small-comment icon-1-star-small"></span>Ricardo Manuel N.</span>
                </div>
            </div>
        </div>

    </div>

</template>

<script>


export default {
    data() {
        return {
            data: {}
        };
    },
    async mounted() {
    },
    methods: {

    },
    components: {

    }
}
</script>
